import { createRouter, createWebHistory } from 'vue-router'
import fireBaseService from '@/services/index.js'
import HomePage from '@/pages/HomePage.vue'
import DashboardPage from '@/pages/DashboardPage.vue'
// import TestDashboardPage from '@/pages/TestDashboard.vue'
import Login from '@/pages/Login.vue'

// const routes = [
//   {
//     path: '/',
//     name: 'HomePage',
//     component: HomePage
//   },

//   {
//     path: '/login',
//     name: 'Login',
//     component: Login
//   },

//   /*{
//     path: '/about',
//     name: 'About',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import( webpackChunkName: "about"  '../views/About.vue')
//   }*/
// ]

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes
// })

// export default router


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'HomePage',
            component: HomePage
        },
        {
            path: '/dashboard',
            name: 'DashboardPage',
            component: DashboardPage
            // component: TestDashboardPage
        },

        {
            path: '/login',
            name: 'Login',
            component: Login
        },
    ]
}
)

router.beforeEach(async (to, from, next) => {
    const userActive = await fireBaseService.getActiveUserSession()
    if (!userActive && !['Login'].includes(to.name) && !['HomePage'].includes(to.name)) {
        next({ name: 'Login' })
    } else {
        next()
    }
})

export default router